import type { LocalizedContent } from './localizedContent';

export class Step {
  public readonly id: string = '';
  public readonly name: string = '';
  public readonly position: number = 0;
  public readonly localizations: LocalizedContent[] = [];

  constructor(props: Partial<Step> = {}) {
    Object.assign(this, props);
  }
}
